import { Link } from 'react-router-dom';
import { MapPin, Phone } from 'lucide-react';

const areas = [
  { name: 'Toronto', hasPage: true, path: '/toronto-appliance-repair' },
  { name: 'East York', hasPage: true, path: '/east-york-appliance-repair' },
  { name: 'North York', hasPage: true, path: '/north-york-appliance-repair' },
  { name: 'Vaughan', hasPage: true, path: '/vaughan-appliance-repair' },
  { name: 'Richmond Hill', hasPage: true, path: '/richmond-hill-appliance-repair' },
  { name: 'King City', hasPage: true, path: '/king-city-appliance-repair' },
  { name: 'Woodbridge', hasPage: true, path: '/woodbridge-appliance-repair' },
  { name: 'Markham', hasPage: true, path: '/markham-appliance-repair' },
];

export const ServiceAreas = () => {
  return (
    <section className="py-20 bg-white" data-testid="service-areas-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span 
            className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4"
            style={{ background: 'rgba(255, 107, 0, 0.1)', color: '#FF6B00' }}
          >
            <MapPin className="inline mr-2" size={16} />
            Local Coverage
          </span>
          <h2 
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif', color: '#1A2B4C' }}
          >
            Serving the Greater Toronto Area
          </h2>
          <p className="text-lg text-[#475569] max-w-2xl mx-auto">
            Same-day appliance repair across 8 GTA communities. Click your city for local service details.
          </p>
        </div>

        {/* Areas Grid - All Clickable */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mb-12">
          {areas.map((area) => (
            <Link
              key={area.name}
              to={area.path}
              className="flex items-center justify-center gap-2 px-4 py-4 rounded-xl font-semibold text-white transition-all hover:scale-105 hover:shadow-lg"
              style={{ background: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}
              data-testid={`area-link-${area.name.toLowerCase().replace(' ', '-')}`}
            >
              <MapPin size={18} />
              {area.name}
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-[#475569] mb-4">Don't see your area? We likely cover it!</p>
          <a
            href="tel:647-919-6893"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-white transition-transform hover:scale-105"
            style={{ background: '#1A2B4C', fontFamily: 'Montserrat, sans-serif' }}
            data-testid="service-areas-cta"
          >
            <Phone size={18} />
            <span>Call to Confirm Service: 647-919-6893</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
